var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('sub-nav-bar'),_c('div',{staticClass:"separator_thin"}),_c('div',{staticClass:"separator_thin"}),_c('router-view'),_c('footer-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }